import QRCode from 'qrcode';

const inr = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

// A shareable PNG: workshop name, amount, QR and the UPI ID / link under it.
export async function advanceQrPng({ value, amount, payee, vpa, number }) {
  const W = 640; const H = 860;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const g = c.getContext('2d');
  g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
  g.fillStyle = '#0f766e'; g.fillRect(0, 0, W, 12);
  g.textAlign = 'center'; g.fillStyle = '#0f172a';
  g.font = '600 30px system-ui, sans-serif'; g.fillText(payee || 'Advance payment', W / 2, 70, W - 60);
  g.font = '400 22px system-ui, sans-serif'; g.fillStyle = '#475569'; g.fillText(`Advance for estimate ${number || ''}`.trim(), W / 2, 108, W - 60);
  g.font = '700 54px system-ui, sans-serif'; g.fillStyle = '#0f172a'; g.fillText(`₹ ${inr(amount)}`, W / 2, 180);
  const qr = document.createElement('canvas');
  await QRCode.toCanvas(qr, value, { width: 440, margin: 1, errorCorrectionLevel: 'M' });
  g.drawImage(qr, (W - 440) / 2, 215, 440, 440);
  g.font = '500 22px system-ui, sans-serif'; g.fillStyle = '#334155';
  g.fillText(vpa ? 'Scan with any UPI app' : 'Scan to pay online', W / 2, 705);
  if (vpa) { g.font = '600 24px ui-monospace, monospace'; g.fillText(vpa, W / 2, 745, W - 60); }
  g.font = '400 18px system-ui, sans-serif'; g.fillStyle = '#94a3b8'; g.fillText('GPay · PhonePe · Paytm · BHIM', W / 2, 800);
  return new Promise((res) => c.toBlob(res, 'image/png'));
}
